<script lang="ts">import { AsyncBetfeed } from "../api/api";
import { stateUi } from "@infinitro/config";
import { Api, ModalDialog, selectedProfile, stateOpenModal } from "@infinitro/global";
import { onDestroy } from "svelte";
import BetFeedTable from "./bet-feed-table.svelte";
let bets = [];
// eslint-disable-next-line no-undef
let interval = undefined;
let stripedInverse = false;
let previousLength = bets.length;
export const openUserInfoModal = (username) => {
	if (username === undefined || username === "" || $stateUi.profileModal.hideOtherPlayerProfile) {
		return;
	}
	selectedProfile.set(username);
	stateOpenModal.set(ModalDialog.OtherProfile);
};
const refreshBetFeed = async () => {
	try {
		const response = await AsyncBetfeed({
			fetchPolicy: "network-only",
			variables: {},
			context: { api: Api.public }
		});
		if (response.data.betfeed) {
			bets = [...response.data.betfeed];
			if (bets.length > previousLength) {
				stripedInverse = !stripedInverse;
				previousLength = bets.length;
			}
			bets = bets.map((bet, index) => {
				return {
					...bet,
					transparentBackground: stripedInverse ? index % 2 === 1 : index % 2 === 0
				};
			});
			bets = bets;
		}
	} catch (e) {} finally {
		interval = setTimeout(refreshBetFeed, 1e3);
	}
};
if (!interval) interval = setTimeout(refreshBetFeed, 1e3);
onDestroy(() => {
	clearTimeout(interval);
});
</script>

<div class="bet-feed-bets-layout">
	<BetFeedTable {bets} {openUserInfoModal} />
</div>

<style>
	.bet-feed-bets-layout {
    width: 100%
}
</style>
